import './RegistrationInvitationCode.css';
import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { getDictionaryItem } from '../../../../utils';
import Loader from '../../../DAcApplication/components/loader';
import { runValidations, validateRequired, validateLength, validateAlphanumeric } from '../../../Login/commomFunctions';
import FormField from '../../../Login/components/FormField';
import { INVITATION_CODE_LENGTH, INVITATION_SUBMIT_LIMIT } from '../constants';
const RegistrationInvitationCode = _ref => {
  let {
    dictionary,
    configuration,
    apiConfig,
    sessionId,
    hide,
    callAfterSubmit,
    rtl,
    username,
    email
  } = _ref;
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [regInvitationLoader, setRegInvitationLoader] = useState(false);
  const [invitationSubmitLimit, setInvitationSubmitLimit] = useState(Number(sessionStorage.getItem('regInvitationSubmitLimit')) || 0);
  const [regInvitationCode, setRegInvitationCode] = useState('');
  const [errorRegInvitationCode, setErrorRegInvitationCode] = useState(invitationSubmitLimit === INVITATION_SUBMIT_LIMIT ? getDictionaryItem(dictionary, 'invitationSubmitLimit') : '');
  const invitationCodeFieldProps = {
    value: regInvitationCode,
    fieldError: errorRegInvitationCode,
    setError: setErrorRegInvitationCode,
    label: getDictionaryItem(dictionary, 'invitationCode'),
    type: 'text',
    id: 'regInvitationCodeCreate',
    name: 'regInvitationCodeCreate',
    placeholder: '',
    labelLight: false,
    errorRequired: getDictionaryItem(dictionary, 'invitationCodeRequired') || ' ',
    errorValue: getDictionaryItem(dictionary, 'invitationCodeInvalid') || ' ',
    requiredLength: INVITATION_CODE_LENGTH,
    autoComplete: '',
    required: true,
    requiredFromContent: true,
    isDisabled: invitationSubmitLimit === INVITATION_SUBMIT_LIMIT,
    changeEvent: value => {
      setRegInvitationCode(value);
    },
    blurEvent: value => {
      invitationCodeFieldProps.validate(value);
    },
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : regInvitationCode;
      const validationResult = runValidations([validateRequired, validateLength, validateAlphanumeric], value, invitationCodeFieldProps);
      return validationResult;
    }
  };
  const regInvitFormSubmit = async event => {
    event.preventDefault();
    if (invitationSubmitLimit === INVITATION_SUBMIT_LIMIT) return;
    setRegInvitationLoader(true);
    setErrorRegInvitationCode('');
    const tokken = Cookies.get('token');
    // const userNameCookie = Cookies.get('username');

    const url = `${apiConfig.apiUrl}/v1/orc/invitationcodes/verify`;
    const headers = new Headers();
    headers.append('X-Request-Id', sessionId);
    headers.append('Apikey', apiConfig.apiKey);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Methods', 'GET,HEAD,POST,OPTIONS');
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Authorization', tokken || '');
    headers.append('Host', 'dacqa.detsandbox.com');
    headers.append('User-Agent', 'Apidog/1.0.0 (https://apidog.com)');
    const data = {
      invitationCode: regInvitationCode,
      username: username,
      email: email
    };
    const requestOptions = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(data)
    };
    let runIncrement = true;
    await fetch(url, requestOptions).then(response => {
      return response.json();
    }).then(result => {
      if (result.hasOwnProperty('desc')) {
        setErrorRegInvitationCode(rtl && result.desc.ar ? result.desc.ar : result.desc.en || '');
      }
      if (result.hasOwnProperty('status') && result.status === true) {
        runIncrement = false;
        sessionStorage.removeItem('authInvitationSubmitLimit');
        callAfterSubmit();
      }
    }).catch(error => {
      setErrorRegInvitationCode(error.message);
      console.error('validateUserRegistrationWithEmail error', error);
    }).finally(() => {
      setRegInvitationLoader(false);
      runIncrement && setInvitationSubmitLimit(prev => {
        const result = prev + 1;
        if (result >= INVITATION_SUBMIT_LIMIT) {
          setErrorRegInvitationCode(prev => {
            return `${prev} \n ${getDictionaryItem(dictionary, 'invitationSubmitLimit')}`;
          });
        }
        sessionStorage.setItem('regInvitationSubmitLimit', String(result));
        return result;
      });
    });
  };
  useEffect(() => {
    if (regInvitationCode && !errorRegInvitationCode) {
      setDisableSubmit(false);
    } else {
      setDisableSubmit(true);
    }
  }, [regInvitationCode, errorRegInvitationCode]);
  return /*#__PURE__*/React.createElement("form", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} dac-login-form`,
    onSubmit: event => regInvitFormSubmit(event)
  }, /*#__PURE__*/React.createElement("div", {
    className: "row dac-login-form__inputs"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4 offset-lg-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: `form-elements-wrap ${errorRegInvitationCode ? 'invalid-field' : ''}`
  }, /*#__PURE__*/React.createElement(FormField, invitationCodeFieldProps))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group lr__form-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-label visibility-hidden d-none d-md-block"
  }, getDictionaryItem(dictionary, 'btnVerify')), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary dac-login-form__submit",
    type: "submit",
    disabled: disableSubmit || regInvitationLoader || invitationSubmitLimit === INVITATION_SUBMIT_LIMIT
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      opacity: regInvitationLoader ? 0 : 1
    }
  }, getDictionaryItem(dictionary, 'btnVerify')), regInvitationLoader ? /*#__PURE__*/React.createElement(Loader, null) : false)))));
};
export default RegistrationInvitationCode;
const commonStyles = "cwyqu2g";
const rtlStyles = "r1ecg59z";
const ltrStyles = "lckq9gk";